import { Injectable } from '@angular/core';
import { ImportDatei, ListenImportEntwurf } from '../Models/listen-import.model';

/**
 * Hält den Arbeitsstand des Mehrfachimports im Speicher der laufenden
 * Anwendung – bewusst NICHT im localStorage: `File`-Objekte lassen sich nicht
 * serialisieren, und ein Entwurf ohne die echten Dateien wäre wertlos.
 *
 * Der Entwurf überlebt damit Navigation innerhalb der App (z. B. kurz ins
 * Projekt und zurück), nicht aber ein Neuladen der Seite.
 */
@Injectable({ providedIn: 'root' })
export class ListenImportEntwurfService {

  private entwurf: ListenImportEntwurf | null = null;

  speichern(entwurf: ListenImportEntwurf): void {
    this.entwurf = {
      projektId: entwurf.projektId,
      projektName: entwurf.projektName,
      dateien: [...entwurf.dateien],
      aktuelleDateiIndex: entwurf.aktuelleDateiIndex,
      schritt: entwurf.schritt
    };
  }

  /** Entwurf desselben Projekts – oder null, wenn keiner (mehr) da ist. */
  laden(projektId: number): ListenImportEntwurf | null {
    if (!this.entwurf || this.entwurf.projektId !== projektId) {
      return null;
    }

    return {
      ...this.entwurf,
      dateien: [...this.entwurf.dateien]
    };
  }

  hatEntwurf(projektId: number): boolean {
    return this.entwurf?.projektId === projektId && this.entwurf.dateien.length > 0;
  }

  leeren(): void {
    this.entwurf = null;
  }

  /** Nur die Dateien, die noch nicht erfolgreich gespeichert wurden. */
  static offeneDateien(dateien: ImportDatei[]): ImportDatei[] {
    return dateien.filter(d => d.importStatus !== 'erfolgreich');
  }
}
